import { HttpClient } from '@shared/adapters/HttpClient';
import { CourierOption } from '../models';

export class CouriersApiAdapter {
    constructor(private httpClient: HttpClient) {}

    /**
     * Obtiene la lista de couriers disponibles
     */
    async getAll(): Promise<CourierOption[]> {
        const raw = await this.httpClient.get<any>('/couriers');
        const list = Array.isArray(raw) ? raw : (raw.data ?? []);
        return list.map((courier: any) => ({
            id: Number(courier.id),
            name: courier.name,
        }));
    }
}

